var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0724 19.0819C16.2182 18.9079 16.2884 18.8105 16.372 18.726C19.3126 15.7476 22.2557 12.7716 25.1948 9.79164C25.585 9.3966 26.0321 9.23938 26.5619 9.41256C27.4094 9.69029 27.6995 10.7389 27.1279 11.4293C27.0585 11.5131 26.9805 11.5897 26.904 11.6671C23.6432 14.9679 20.3817 18.2687 17.1201 21.5703C16.4358 22.2622 15.7491 22.2662 15.0711 21.579C11.7954 18.2639 8.52119 14.9471 5.24229 11.636C4.85835 11.2481 4.65573 10.8179 4.80947 10.2673C5.05466 9.39021 6.0969 9.05343 6.80251 9.62245C6.90185 9.70305 6.99015 9.79803 7.08081 9.889C9.99469 12.8378 12.9094 15.7867 15.8209 18.7379C15.9029 18.8209 15.9612 18.9287 16.0724 19.0819Z",
    fill: "#273239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/drop-down.10bce8b7ca425b879aad007f458609c8.svg";
export { ForwardRef as ReactComponent };